module.exports = __webpack_public_path__ + "static/media/TUNE_6740.7cc178bd.jpg";